export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_nl-4a1877ee.png";